var chunkToChildrenMap = {
	"50": [
		180
	],
	"52": [
		180
	],
	"196": [
		180
	],
	"766": [
		112,
		415,
		52
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };